
    import Vue from 'vue';
    import XSummary from '@/apps/shared/components/summary.vue';
    import CUPEService from '@/apps/shared/services/cupe-service';
    import saveEmissionService from '../../../shared/services/saveEmission-service';
    import getSelectedProducerService from '../../../shared/services/selectedProducer-service';
    import DateService from '@/apps/shared/utils/formatDate';
    import { SummaryDetails } from '@/apps/shared/models/summaryDetails';
    import DiscountRangeService from '@/apps/shared/services/getDiscountRange-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper'; 
    import { SaveMultiQuoteNotificationsRequest } from '@/apps/shared/models/saveMultiQuoteNotificationsRequest';
    import ParamCotizService from '@/apps/shared/services/ParamCotizOfSession-service';   

    export default Vue.extend({
        components: {
            XSummary,
        },
        name: 'healthMaxPayment-view',
        data() {
            return {
                productDetails: {
                    product: "/salud-segura-max",
                    effectDate: null,
                    expirationDate: null,
                    name: null,
                    email: null,
                    telephone: null,
                    cover: null,
                    planDescription: null,
                    firstPaymentFee: null,
                    capital: null,
                    undiscountedPrice: null,
                    rate: null,
                    cupeUrl: null,
                    breadcrumbItems: [
                        { text: 'Inicio', path: '/salud-segura-max' },
                        { text: 'Resumen', path: 'salud-segura-max/resumen' },
                    ],
                    icon: {
                        src: '/Logos/salud.svg',
                        alt: 'HealtMax',
                        title: 'HealtMax'
                    },
                } as SummaryDetails,
                GUiD: null,
                capital: null,
                additionalCovers: [],
                coversDetail: [],
                planName: null,
                effectDate: null,
                primerCuota: 0,
                DataPlan: {
                    planDescription: ''
                },
                expirationDate: null,
                activeStep: 0,
                description: true,
                currentStep: 1,
                totalStep: 2,
                isAssuredTitular: false,
                dataTabHome: null,
                policyOwner: null,
                personToCover: null,
                clientCode: "0",
                originId: 2,
                breadcrumItems: [{ text: 'Inicio', path: '/salud-segura-max' },
                { text: 'Contratar', path: '/salud-segura-max/pago' }],
                thereIsDiscount: false,
                premiumWithoutDiscount: null,
                referente: null,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Salud Segura Max';
                const actualPath = '/salud-segura-max';
                const actualStep = 'summary';

                const planData = JSON.parse(sessionStorage.getItem("PlanSelected"));
                const clientData = JSON.parse(sessionStorage.getItem("policyOwner"));
                const dataTabHome = JSON.parse(sessionStorage.getItem("DataTabHome"));
                const peopleToCover = parseInt(sessionStorage.getItem("peopleToCover"), 10);

                const request = new SaveMultiQuoteNotificationsRequest();
                request.lastName = clientData.lastName;
                request.firstName = clientData.firstName;
                request.phone = clientData.areaCode + clientData.telephone;
                request.mail = clientData.email;
                request.quotePlan = planData.planDescription;
                request.quotationDetail = "Producto: " + defaultTitle
                    + " - Localidad: " + dataTabHome.selectedLocality.text
                    + " - Personas: " + peopleToCover;

                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, request);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultSafeHealthMaxGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            setSessionParams() {
                const rawPolicyOwner = JSON.parse(sessionStorage.getItem('policyOwner'));
                const rawHealthQuotation = JSON.parse(sessionStorage.getItem('responseHealth321Quotation'));
                const rawPlanSelected = JSON.parse(sessionStorage.getItem('PlanSelected'));
                const rawLeadId = JSON.parse(sessionStorage.getItem('LeadId'));
                const rawSelectedPricingId = JSON.parse(sessionStorage.getItem('selectedPricingId'));
                const rawClientData = JSON.parse(sessionStorage.getItem('clientData'));
                const rawDataTabHome = JSON.parse(sessionStorage.getItem('DataTabHome'));
                const rawPlanDescription = JSON.parse(sessionStorage.getItem('PlanDescription'));

                const payload = {
                    productId: 321,
                    pricingId: rawPlanSelected.pricingId[0],
                    policyOwner: {
                        firstName: rawPolicyOwner.firstName,
                        lastName: rawPolicyOwner.lastName,
                        documentNumber: rawPolicyOwner.numDoc,
                        email: rawPolicyOwner.email,
                    },
                    healthQuotation: {
                        effectDate: rawHealthQuotation.effectDate,
                        expirationDate: rawHealthQuotation.expirationDate,
                    },
                    planSelected: {
                        planDescription: rawPlanSelected.planDescription,
                        premioMensual: rawPlanSelected.premioMensual,
                        pricingId: rawPlanSelected.pricingId[0],
                    },
                    leadId: rawLeadId,
                    selectedPricingId: rawSelectedPricingId,
                    clientData: {
                        firstName: rawClientData.firstName,
                        lastName: rawClientData.lastName,
                        documentNumber: rawClientData.documentNumber,
                        areaCode: rawClientData.areaCode,
                        telephone: rawClientData.telephone,
                        email: rawClientData.email,
                    },
                    dataTabHome: {
                        selectedLocality: {
                            name: rawDataTabHome.selectedLocality.name,
                            zipCode: rawDataTabHome.selectedLocality.zipCode,
                        },
                    },
                    planDescription: rawPlanDescription,
                    referente: this.referente,
                };

                const jsonString = JSON.stringify(payload);

                return ParamCotizService.setParamCotiz(jsonString)
                    .then(guid => {
                        this.GUiD = guid;
                    })
                    .catch(err => {
                        console.error("Error en setSessionParams:", err);
                    });
            },

            saveEmission: function () {
                NF.UI.Page.block();
                try {
                    // Obtener datos desde sessionStorage
                    this.dataTabHome = JSON.parse(sessionStorage.getItem("DataTabHome"));
                    this.policyOwner = JSON.parse(sessionStorage.getItem("policyOwner"));
                    this.personToCover = JSON.parse(sessionStorage.getItem("personToCover"));

                    // Llamar a getSelectedProducerService.GetSelectedProducer y luego proceder con la creación del objeto
                    getSelectedProducerService.GetSelectedProducer(
                        this.clientCode,
                        parseInt(this.dataTabHome.cityId),
                        0,
                        this.originId,
                        this.dataTabHome.zipCode
                    ).then(() => {
                        let JsonEmissionData = null;
                        //Se consume el Servicio de SaveEmission con los datos correspondientes
                        let birthday = this.policyOwner.birthday;
                        if (birthday == null || birthday == undefined) {
                            birthday = "01/01/1900";
                        };
                        let planData = JSON.parse(sessionStorage.getItem("responseHealth321Quotation"));
                        let dateFormat = new Date(birthday);
                        let titular = this.policyOwner;//tomador
                        let insuranceBeneficiary = this.personToCover != null ? this.personToCover : this.policyOwner;//insuranceBeneficiary
                        let roles = {
                            clientRole: {
                                additionalClientRole: {
                                    client: [
                                        //Titular - beneficiario
                                        {
                                            additionalClientRole: null,
                                            address: {
                                                department: titular.address == null ? null : titular.address.department?.toString() ?? "",
                                                floor: parseInt(titular.address == null ? null : titular.address.floor ?? 0),
                                                streetName: titular.address == null ? "" : titular.address.streetName?.toString() ?? "",
                                                streetNumber: titular.address == null ? "" : titular.address.numDom?.toString() ?? "",
                                            },
                                            birthday: new Date(titular.birthday),
                                            cityCode: parseInt(titular.selectedLocality != null ? titular.selectedLocality.id : this.dataTabHome.cityId),
                                            documentNumber: parseInt(titular.numDoc),
                                            documentType: titular.docTypeSelected.id.trim(),
                                            email: titular.email != null ? titular.email.toString() : null,
                                            gender: null,
                                            firstName: (titular.firstName != null && titular.firstName != "") ? titular.firstName.toString() : "",
                                            lastName: (titular.lastName != null && titular.lastName != "") ? titular.lastName.toString() : " ",
                                            phones: [{
                                                areaCode: titular.telephone == null || titular.telephone == undefined ? null : parseInt(titular.areaCode),
                                                countryCode: null,
                                                order: null,
                                                phoneNumber: titular.telephone == null || titular.telephone == undefined ? "" : titular.telephone.toString(),
                                                phoneType: null
                                            }],
                                            relationCode: 18, //Titular
                                            roleCode: 17, //beneficiario
                                            ivaConditionId: parseInt(titular.selectedIvaCondition.id),
                                            zipCode: titular.address != null ? titular.address.zipCode : this.dataTabHome.zipCode,
                                        },
                                        //Titular - asegurado titular
                                        {
                                            additionalClientRole: null,
                                            address: {
                                                department: insuranceBeneficiary.address == null ? null : insuranceBeneficiary.address.department?.toString() ?? "",
                                                floor: parseInt(insuranceBeneficiary.address == null ? null : insuranceBeneficiary.address.floor ?? 0),
                                                streetName: insuranceBeneficiary.address == null ? "" : insuranceBeneficiary.address.streetName?.toString() ?? "",
                                                streetNumber: insuranceBeneficiary.address == null ? "" : insuranceBeneficiary.address.numDom?.toString() ?? "",
                                            },
                                            birthday: new Date(insuranceBeneficiary.birthday),
                                            cityCode: parseInt(insuranceBeneficiary.selectedLocality != null ? insuranceBeneficiary.selectedLocality.id : this.dataTabHome.cityId),
                                            documentNumber: parseInt(insuranceBeneficiary.numDoc),
                                            documentType: insuranceBeneficiary.docTypeSelected.id.trim(),
                                            email: insuranceBeneficiary.email != null ? insuranceBeneficiary.email.toString() : null,
                                            gender: null,
                                            firstName: (insuranceBeneficiary.firstName != null && insuranceBeneficiary.firstName != "") ? insuranceBeneficiary.firstName.toString() : "",
                                            lastName: (insuranceBeneficiary.lastName != null && insuranceBeneficiary.lastName != "") ? insuranceBeneficiary.lastName.toString() : " ",
                                            phones: [{
                                                areaCode: insuranceBeneficiary.telephone == null || insuranceBeneficiary.telephone == undefined ? null : parseInt(insuranceBeneficiary.areaCode),
                                                countryCode: null,
                                                order: null,
                                                phoneNumber: insuranceBeneficiary.telephone == null || insuranceBeneficiary.telephone == undefined ? "" : insuranceBeneficiary.telephone.toString(),
                                                phoneType: null
                                            }],
                                            relationCode: 18, //Titular
                                            roleCode: 36, //Asegurado Titular
                                            ivaConditionId: parseInt(insuranceBeneficiary.selectedIvaCondition.id),
                                            zipCode: insuranceBeneficiary.address != null ? insuranceBeneficiary.address.zipCode : this.dataTabHome.zipCode,
                                        },
                                    ]
                                },
                                address: {
                                    department: titular.address == null ? null : titular.address.department?.toString() ?? "",
                                    floor: parseInt(titular.address == null ? null : titular.address.floor ?? 0),
                                    streetName: titular.address == null ? "" : titular.address.streetName?.toString() ?? "",
                                    streetNumber: titular.address == null ? "" : titular.address.numDom?.toString() ?? "",
                                },
                                birthday: new Date(titular.birthday),
                                cityCode: parseInt(titular.selectedLocality != null ? titular.selectedLocality.id : this.dataTabHome.cityId),
                                documentNumber: parseInt(titular.numDoc),
                                documentType: titular.docTypeSelected.id.trim(),
                                email: titular.email != null ? titular.email.toString() : null,
                                gender: null,
                                firstName: (titular.firstName != null && titular.firstName != "") ? titular.firstName.toString() : "",
                                lastName: (titular.lastName != null && titular.lastName != "") ? titular.lastName.toString() : " ",
                                phones: [{
                                    areaCode: titular.telephone == null || titular.telephone == undefined ? null : parseInt(titular.areaCode),
                                    countryCode: null,
                                    order: null,
                                    phoneNumber: titular.telephone == null || titular.telephone == undefined ? "" : titular.telephone.toString(),
                                    phoneType: null
                                }],
                                relationCode: null,
                                roleCode: 1, //Tomador,
                                ivaConditionId: parseInt(titular.selectedIvaCondition.id),
                                zipCode: titular.address != null ? titular.address.zipCode : this.dataTabHome.zipCode,
                            }
                        };
                        let peopleToCover = parseInt(sessionStorage.getItem("peopleToCover"));
                        if (peopleToCover > 1) {
                            let familyMembers = JSON.parse(sessionStorage.getItem("familyMembers"));
                            familyMembers.forEach(familyMember => {
                                roles.clientRole.additionalClientRole.client.push(
                                    {
                                        additionalClientRole: [{
                                            additionalClientRole: null,
                                            address: {
                                                department: insuranceBeneficiary.address == null ? null : insuranceBeneficiary.address.department?.toString() ?? "",
                                                floor: parseInt(insuranceBeneficiary.address == null ? null : insuranceBeneficiary.address.floor ?? 0),
                                                streetName: insuranceBeneficiary.address == null ? "" : insuranceBeneficiary.address.streetName?.toString() ?? "",
                                                streetNumber: insuranceBeneficiary.address == null ? "" : insuranceBeneficiary.address.numDom?.toString() ?? "",
                                            },
                                            birthday: new Date(insuranceBeneficiary.birthday),
                                            cityCode: parseInt(insuranceBeneficiary.selectedLocality != null ? insuranceBeneficiary.selectedLocality.id : this.dataTabHome.cityId),
                                            documentNumber: parseInt(insuranceBeneficiary.numDoc),
                                            documentType: insuranceBeneficiary.docTypeSelected.id.trim(),
                                            email: insuranceBeneficiary.email != null ? insuranceBeneficiary.email.toString() : null,
                                            gender: null,
                                            firstName: (insuranceBeneficiary.firstName != null && insuranceBeneficiary.firstName != "") ? insuranceBeneficiary.firstName.toString() : "",
                                            lastName: (insuranceBeneficiary.lastName != null && insuranceBeneficiary.lastName != "") ? insuranceBeneficiary.lastName.toString() : " ",
                                            phones: [{
                                                areaCode: insuranceBeneficiary.telephone == null || insuranceBeneficiary.telephone == undefined ? null : parseInt(insuranceBeneficiary.areaCode),
                                                countryCode: null,
                                                order: null,
                                                phoneNumber: insuranceBeneficiary.telephone == null || insuranceBeneficiary.telephone == undefined ? "" : insuranceBeneficiary.telephone.toString(),
                                                phoneType: null
                                            }],
                                            relationCode: 18, //Titular
                                            roleCode: 36, //Asegurado Titular
                                            ivaConditionId: parseInt(insuranceBeneficiary.selectedIvaCondition.id),
                                            zipCode: insuranceBeneficiary.address != null ? insuranceBeneficiary.address.zipCode : this.dataTabHome.zipCode,
                                        }],
                                        address: {
                                            department: familyMember.address == null ? null : familyMember.address.department?.toString() ?? "",
                                            floor: parseInt(familyMember.address == null ? null : familyMember.address.floor ?? 0),
                                            streetName: familyMember.address == null ? "" : familyMember.address.streetName?.toString() ?? "",
                                            streetNumber: familyMember.address == null ? "" : familyMember.address.numDom?.toString() ?? "",
                                        },
                                        birthday: new Date(familyMember.birthday),
                                        cityCode: parseInt(familyMember.selectedLocality != null ? familyMember.selectedLocality.id : this.dataTabHome.cityId),
                                        documentNumber: parseInt(familyMember.docNum),
                                        documentType: familyMember.docType.id.trim(),
                                        email: familyMember.email != null ? familyMember.email.toString() : null,
                                        gender: null,
                                        firstName: (familyMember.firstName != null && familyMember.firstName != "") ? familyMember.firstName.toString() : "",
                                        lastName: (familyMember.lastName != null && familyMember.lastName != "") ? familyMember.lastName.toString() : " ",
                                        phones: [{
                                            areaCode: familyMember.telephone == null || familyMember.telephone == undefined || familyMember.telephone == "" ? null : parseInt(familyMember.areaCode),
                                            countryCode: null,
                                            order: null,
                                            phoneNumber: familyMember.telephone == null || familyMember.telephone == undefined || familyMember.telephone == "" ? "" : familyMember.telephone.toString(),
                                            phoneType: null
                                        }],
                                        relationCode: familyMember.relation.relationId, //familyMember
                                        roleCode: 28, //Asegurado Familiar
                                        ivaConditionId: parseInt(familyMember.selectedIvaCondition.id),
                                        zipCode: familyMember.address != null ? familyMember.address.zipCode : this.dataTabHome.zipCode,
                                    }
                                );
                            });
                        }
                        JsonEmissionData = JSON.stringify({
                            birthday: dateFormat,
                            cityCode: this.policyOwner.address != null ? this.policyOwner.address.cityId : parseInt(this.dataTabHome.cityId),
                            clientAddress: {
                                department: this.policyOwner.address == null ? null : this.policyOwner.address.department?.toString() ?? "",
                                floor: parseInt(this.policyOwner.address == null ? null : this.policyOwner.address.floor ?? 0),
                                streetName: this.policyOwner.address == null ? "" : this.policyOwner.address.streetName?.toString() ?? "",
                                streetNumber: this.policyOwner.address == null ? "" : this.policyOwner.address.numDom?.toString() ?? "",
                            },
                            clientFirstName: (this.policyOwner.firstName != null && this.policyOwner.firstName != "") ? this.policyOwner.firstName.toString() : "",
                            clientLastName: (this.policyOwner.lastName != null && this.policyOwner.lastName != "") ? this.policyOwner.lastName.toString() : " ",
                            documentNumber: parseInt(this.policyOwner.numDoc),
                            documentType: this.policyOwner.docTypeSelected.id.trim(),
                            effectDate: planData.effectDate,
                            email: this.policyOwner.email != null ? this.policyOwner.email.toString() : null,
                            observations: null,
                            paymentType: 0,
                            phones: [{
                                areaCode: titular.telephone == null || titular.telephone == undefined ? null : parseInt(titular.areaCode),
                                countryCode: null,
                                order: null,
                                phoneNumber: titular.telephone == null || titular.telephone == undefined ? "" : titular.telephone.toString(),
                                phoneType: null
                            }],
                            roles: roles,
                            pricingId: parseInt(sessionStorage.getItem("selectedPricingId")),
                            zipCode: this.policyOwner.address != null ? this.policyOwner.address.zipCode : this.dataTabHome.zipCode,
                            swornDeclarations: JSON.parse(sessionStorage.getItem("SwornDeclarationArray")),
                        });

                        // Enviar datos de emisión
                        saveEmissionService.HealthSaveEmission(JsonEmissionData)
                            .then(response => {
                                if (!response.validationResult || response.validationResult.errorMessage === "Los datos para la emisión se guardaron correctamente") {
                                    NF.UI.Page.unblock();
                                    return true;
                                } else {
                                    console.error("Error en respuesta de HealthSaveEmission:", response.validationResult.errorMessage);
                                    this.showRuletaErrorModal(true);
                                    NF.UI.Page.unblock();
                                    return false;
                                }
                            })
                            .catch(error => {
                                console.error("Error en HealthSaveEmission:", error);
                                this.showRuletaErrorModal(true);
                                NF.UI.Page.unblock();
                                return false;
                            });
                    }).catch(error => {
                        console.error("Error en GetSelectedProducer:", error);
                        this.showRuletaErrorModal(true);
                        NF.UI.Page.unblock();
                    });
                } catch (error) {
                    console.error("Error en saveEmission:", error);
                    this.showRuletaErrorModal(true);
                    NF.UI.Page.unblock();
                }
            }
            ,

            showRuletaErrorModal(show) {
                if (show) {
                    this.$refs.modalErrorRuleta.open();
                }
                else {
                    this.$refs.modalErrorRuleta.close();
                }
            },

            getCUPE: function () {
                let productId = 321;
                let policyOwner = JSON.parse(sessionStorage.getItem("policyOwner"));
                var timeStart = new Date().getTime();
                NF.UI.Page.block();
                CUPEService.GetCUPEUrl(productId, policyOwner.email, this.GUiD).then(response => {
                    this.productDetails.cupeUrl = response.preferenceMessage;
                    var endTime = new Date().getTime();
                    var secondCharge = Math.round((endTime - timeStart) / 1000);
                    window.globalThis.dataLayer.push({
                        'pas': null,
                        'email': JSON.parse(sessionStorage.getItem("policyOwner")).email,
                        'product': 'salud',
                        'event': 'cotizador-salud-resumen',
                        'carga': secondCharge,
                        'referente': this.referente
                    });
                    NF.UI.Page.unblock();
                }).catch((error) => {
                    console.error('Error al obtener la URL:', error);
                }).finally(() => {
                    NF.UI.Page.unblock();
                });
            },

            async fetchSessionPayload() {
                const guid = sessionStorage.getItem('ParamId');
                if (guid)
                    await ParamCotizService.getParamCotiz(guid);
            },
            
            async getInitData() {
                sessionStorage.setItem("ExitOrContinueModal", "true");
                let data = JSON.parse(sessionStorage.getItem("responseHealth321Quotation"));
                const formatDate = (dateString: string): string => {
                    const date = new Date(dateString);
                    const day = date.getDate().toString().padStart(2, '0');
                    const month = (date.getMonth() + 1).toString().padStart(2, '0');
                    const year = date.getFullYear().toString();
                    return `${day}/${month}/${year}`;
                };
                // Asignar las fechas formateadas
                this.effectDate = formatDate(data.effectDate);
                this.expirationDate = formatDate(data.expirationDate);
                this.currentStep = this.totalStep = parseInt(sessionStorage.getItem("totalStep"));
                this.isAssuredTitular = Boolean(sessionStorage.getItem("isAssuredTitular"));

                const today = new Date();
                const nextYearDate = new Date(today);
                nextYearDate.setFullYear(today.getFullYear() + 1);

                this.productDetails.effectDate = DateService.formatDate(today);
                this.productDetails.expirationDate = DateService.formatDate(nextYearDate);

                const personData = sessionStorage.getItem("policyOwner");
                const planDataSelected = sessionStorage.getItem("PlanSelected");
                this.currentGroup = parseInt(JSON.parse(sessionStorage.getItem("groupSelected")).id);
                const cover = sessionStorage.getItem("getHealthCoverCapitalAndDescription-Group" + (this.currentGroup));

                if (personData != null) {
                    const person = JSON.parse(personData!);
                    this.productDetails.name = person.firstName + ' ' + person.lastName;
                    this.productDetails.email = person.email;
                    this.productDetails.telephone = person.areaCode + '-' + person.telephone;
                }

                if (cover != null) {
                    const dataCover = JSON.parse(cover!)
                    this.productDetails.cover = dataCover
                }


                if (planDataSelected != null) {
                    const dataPlan = JSON.parse(planDataSelected!);
                    this.productDetails.planDescription = dataPlan.planDescription;
                    this.productDetails.firstPaymentFee = dataPlan.premioMensual.toLocaleString('de-DE', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                    });
                    this.productDetails.undiscountedPrice = dataPlan.premiumWithoutDiscount?.toLocaleString('de-DE', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                    });;
                    NF.UI.Page.blockCustom({ message: 'Cargando datos..' });
                    await DiscountRangeService.getSafeHealthMaxDiscountRange().then((response) => {
                        if (response.length > 0) {
                            this.productDetails.rate = response[0].discountMaxValue;
                        }
                    }).finally(() => {
                        NF.UI.Page.unblock();
                    });
                }
            },
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente; 

                await this.fetchSessionPayload();

                await this.pageCustomization();

                const parallelPromises = [
                    this.updateByProductGoogleAnalytics(),
                    this.saveEmission(),
                    this.getInitData(),
                    this.setSessionParams()
                ];

                await Promise.all([
                    ...parallelPromises,
                ]);

                this.getCUPE();

            } finally {
                NF.UI.Page.unblock();
            }
        },
    });
